module.exports = __webpack_public_path__ + "static/media/MyPartyInActive.62cd8586.svg";